import { toast } from "react-toastify";

export const handleError = (error, autoCloseTime) => {
    let message;

    if (!error?.response?.status) {
        message = "It seems there is a network issue. Please check your internet connection or refresh the page.";
    } else if (error?.response?.status === 500) {
        message = "Oops! Something went wrong on our end. We're working to fix this. Please try again later.";
    } else if (error?.response?.status === 404) {
        message = "The requested resource was not found. Please check the URL or contact support if the issue persists.";
    } else {
        message = error?.response?.data?.message ||
            "Apologies for the inconvenience. We are currently addressing an unexpected error.";
    }

    toast.error(message, { autoClose: autoCloseTime });
};
